import { useState } from 'react';

import CustomerSatisfactionData from './CustomerSatisfactionData';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const INITIAL_PERSON_SUBSCRIPTIONS_STATE = {
  ...BASIC_INITIAL_STATE
};

const usePersonCustomerSatisfactionData = () => {
  const [personCustomerSatisfactionState, setPersonCustomerSatisfactionState] = useState(INITIAL_PERSON_SUBSCRIPTIONS_STATE);

  const getPersonCustomerSatisfaction = (personId) => {
    return CustomerSatisfactionData.getPersonCustomerSatisfactionData(personId, personCustomerSatisfactionState, setPersonCustomerSatisfactionState);
  };

  return {
    personCustomerSatisfactionState,
    getPersonCustomerSatisfaction
  };
};

export default usePersonCustomerSatisfactionData;